import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import '../../assets/Interior/ai-theta-pro.jpg.mjs';
import '../../assets/product-list-assets/cameras/interior-design/ai-theta-professional.jpg.mjs';
import { interiorDesign as interiorDesign$1 } from '../product-groups/cameraSecurity/InteriorDesign.mjs';
import { interiorDesign } from '../product-list-groups/interiorDesign.mjs';
import { deployment } from '../properties/deployment.mjs';
import { outdoorReady } from '../properties/outdoorReady.mjs';
import v3Image__default from "../../../../assets/ai-theta-pro.jpg";
import image__default from "../../../../assets/ai-theta-professional.jpg";
"use strict";
const aiThetaPro = {
  id: "thetaPro",
  productTitle: "AI Theta Pro",
  techspecsPath: [SiteId.TechSpecs, "/unifi/cameras-nvrs/uvc-ai-theta-pro"],
  storePathParts: {
    productSlug: "uvc-ai-theta-pro",
    category: "cameras-theta"
  },
  sku: "UVC-AI-Theta-Pro",
  description: "thetaPro.description",
  image: {
    src: image__default,
    width: 200,
    height: 140
  },
  v3Image: {
    src: v3Image__default,
    width: 250,
    height: 182
  },
  productGroup: interiorDesign$1,
  productListGroup: interiorDesign,
  propertyValues: [{
    propertyId: "dimensions",
    value: {
      type: "string",
      value: "UVC-AI-Theta-Hub:\n140 x 70 x 38 mm\n(5.5 x 2.8 x 1.5\u201D)\n\n\nUVC-AI-Theta-ProLens360:\n\xD836.6 x 58.9 mm\n(\xD81.4 x 2.3\u201D)\n\n\nUVC-AI-Theta-ProLens360 Flush mount:\n\xD854.6 x 60.4 mm\n (\xD82.2 x 2.4\u201D)"
    }
  }, {
    propertyId: "cameraResolution",
    value: {
      type: "string",
      value: "4K"
    }
  }, {
    propertyId: "imageSensor",
    value: {
      type: "string",
      value: '8MP 1/1.8" CMOS'
    }
  }, {
    propertyId: "fieldOfView",
    value: {
      type: "translation",
      value: "thetaPro.fieldOfView"
    }
  }, {
    propertyId: "nightVision",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "faceRecognition",
    value: {
      type: "translation",
      value: "thetaPro.faceRecognition"
    }
  }, {
    propertyId: "opticalZoom",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "smartDetections",
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: "enhancedDetections",
    value: {
      type: "boolean",
      value: true
    }
  }, {
    propertyId: "licensePlateRecognition",
    value: {
      type: "translation",
      value: "thetaPro.licensePlateRecognition"
    }
  }, {
    propertyId: "aiRecognition",
    value: {
      type: "translation",
      value: "thetaPro.aiRecognition"
    }
  }, {
    propertyId: "cameraAudio",
    value: {
      type: "translation",
      value: "thetaPro.cameraAudio"
    }
  }, {
    propertyId: outdoorReady.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "tamperResistance",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: deployment.id,
    value: {
      type: "string",
      value: "PoE"
    }
  }]
};
export { aiThetaPro };
//# sourceMappingURL=thetaPro.mjs.map
